// Module
var code = " {{# [['clusterNumber', 'color-02'], ['clusterLabel', 'color-03']].forEach(function(clusterInfo) { }} <span class=\"odf-text odf-text-md odf-strong odf-text-mono-{{ clusterInfo[1] }} od-custom-marker-cluster-labeled\"> {{ data[clusterInfo[0]] }} </span> {{# }); }} ";
// Exports
module.exports = code;